
// Mutations
export const RESETMEMBERS = 'RESETMEMBERS';

// Actions
export const GETMEMBERS = 'GETMEMBERS';

import db from '../../firebase/firebase'
import { compareByName } from '../../functions/general'

export default {
  state: () => ({
    members: [],
  }),
  
  getters: {

  },

  mutations: {
    [RESETMEMBERS] ( state ) {
      state.members = []
    },

    setMembers ( state, members ) {
      state.members = members
    },
  },

  actions: {
    async [GETMEMBERS] ( { commit }, { guild } ) {
      if( !guild ) return

      // Retrieve guild members from RTDB, but with 'get' so just once
      // and store it in state.members
      try{
        let snapshot = await db.ref( 'guildMembers/' + guild['.key'] ).get()

        let data = snapshot.val()

        let members = []
        for( let index in data ) {
          members.push( { name: data[index].name, playerid: index })
        }
        commit( 'setMembers', members.sort( compareByName ) )

      } catch( error ) {
        console.error( error )
      }
    },
  },
}